export const pcTabHomePathMap = {
  lesson: '/main/schedule',
  class: '/main/classmanagement',
  student: '/main/studentmanage',
  student_manage: '/main/studentmanage',
  history_student_manage: '/main/studentmanage',
  student_order: '/main/signup',
  CRM: '/main/crm',
  crm: '/main/recruitstudent',
  finance: '/main/finance',
  analysis: '/main/statistic',
  org_group_dashboard: '/main/statistic',
  sales_manage: '/main/salesmanage',
  sales_following_leads_manage: '/main/salesmanage',
  sales_public_sea_manage: '/main/salesmanage',
  sales_need_follow_manage: '/main/salesmanage',
  sales_trial_manage: '/main/salesmanage',
  sales_leads_field_setting: '/main/salesmanage',
  org_leads: '/main/query',
  success_order_detail: '/main/query',
  query: '/main/query',
  org_manage: '/main/managesettings',
  org_info: '/main/managesettings',
  region_org_manage: '/main/managesettings',
  staff_manage: '/main/managesettings',
  course_manage: '/main/managesettings',
  card_type_manage: '/main/managesettings',
  org_setting: '/main/managesettings',
  sundry_manage: '/main/managesettings',
  sundry_stock_record: '/main/managesettings',
  goods_manage: '/main/managesettings',
  template_manage: '/main/managesettings',
  course_resource_manage: '/main/classmanagement/course_resource_manage',
  practice_plan_manage: '/main/classmanagement/practice_plan_manage',
  course_resource_binds: '/main/classmanagement/course_resource_binds'
}

export function getHomePathFromPcTabs (pcTabs) {
  if (!Array.isArray(pcTabs) || !pcTabs.length) {
    return '/auth-redirect'
  }
  for (const tab of pcTabs) {
    if (pcTabHomePathMap[tab]) {
      return pcTabHomePathMap[tab]
    }
  }
  return '/auth-redirect'
}
